import { useCallback, useEffect, useMemo, useState } from "react";
import { Box } from "@chakra-ui/react";
import ComplexTable from "views/admin/default/components/ComplexTable";
import { columnsDataComplex } from "views/admin/default/variables/columnsData";
import { useDispatch, useSelector } from "react-redux";
import { FetchCampaignsOverview } from "../../../redux/changeLog/action";
import { RootReducer } from "../../../RootReducer";
import { useHistory } from "react-router-dom";
import { scrollToTop } from "utils";
import { getPartners } from "../partners/services";
import { FilterDefinition } from "hooks/useTable";

interface Filters {
  partnerId?: number;
}

export default function Overview() {
  const dispatch = useDispatch();
  const history = useHistory();

  const searchParams = new URLSearchParams(window.location.search);
  const pageNumber = searchParams.get("page") || 1;

  const [currentPageNumber, setCurrentPageNumber] = useState(
    Number(pageNumber) ?? 1
  );
  const [recordPerPage, setRecordPerPage] = useState(25);
  const [filters, setFilters] = useState<Filters>({});
  const [partners, setPartners] = useState([]);

  const campaignChangeRequestState = useSelector(
    (state: RootReducer) => state.overview.fetchCampaignChangesRequestState
  );
  const campaignChanges = useSelector(
    (state: RootReducer) => state.overview.campaignChanges
  );

  const updateFilter = (key: string, value: any) => {
    if (key === "partnerId") {
      value = parseInt(value);
    }
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const totalCampaignChangeCount = useSelector(
    (state: RootReducer) => state.overview.totalCampaignChangeCount
  );

  const totalPageCount =
    Math.floor(totalCampaignChangeCount / recordPerPage) + 1;
  const isReportSuccessful =
    !campaignChangeRequestState.isLoading ||
    campaignChangeRequestState.isSuccessful;

  const handlePageNumberPress = useCallback(
    (number: number) => {
      const newSearchParams = new URLSearchParams({ page: number.toString() });

      history.push({ search: newSearchParams.toString() });
      setCurrentPageNumber(number);
      scrollToTop();
    },
    [history]
  );
  useEffect(() => {
    dispatch(
      FetchCampaignsOverview(
        recordPerPage,
        currentPageNumber,
        filters.partnerId
      )
    );
  }, [dispatch, currentPageNumber, recordPerPage, filters]);

  const FILTERS: FilterDefinition[] = useMemo(() => {
    return [
      {
        label: "",
        filterKey: "partnerId",
        type: "selectbox",
        options: partners,
        placeholder: "Select a partner",
      },
    ];
  }, [partners]);

  useEffect(() => {
    getPartners({
      page: 1,
      pageSize: 1000,
      filters: {
        hasAtLeastOneCampaign: true,
      },
    }).then((res) => {
      const formattedPartners = res?.data?.map((partner) => {
        return {
          label: partner.companyName,
          value: partner.partnerId,
        };
      });
      setPartners(formattedPartners);
    });
  }, [dispatch]);

  let tableColumns = columnsDataComplex;

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <ComplexTable
        isLoading={!isReportSuccessful}
        columnsData={tableColumns}
        tableData={campaignChanges ?? []}
        currentPageNumber={currentPageNumber}
        onPageNumberPress={handlePageNumberPress}
        totalPageCount={totalPageCount}
        filters={FILTERS}
        updateFilter={updateFilter}
      />
    </Box>
  );
}
